import { Platform } from 'react-native';
import styled from 'styled-components/native';

export default styled.View`
  margin-bottom: ${Platform.OS === 'web' ? 20 : 10}px;
  width: 100%;
  height: auto;
`;
